import { Store } from "utilities/Redux/store"

export const getFeed = (state: Store) => state.feed
